module.exports = __webpack_public_path__ + "img/login-logo.a3474500.png";